export const environment = {
  production: true,
  autServer:  'http://elbahr.wiio.pl:8081'
};



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/environments/environment.ts